import { render, staticRenderFns } from "./PersonalInfoForm.vue?vue&type=template&id=1a5e8264&scoped=true&"
import script from "./PersonalInfoForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PersonalInfoForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PersonalInfoForm.vue?vue&type=style&index=0&id=1a5e8264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5e8264",
  null
  
)

export default component.exports